import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "/node_modules/bootstrap/dist/css/bootstrap.min.css";
import TableContainer from "../../Components/Common/TableContainer";
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";

import {
  getJobList as onGetJobList,
  addNewJobList as onAddNewJobList,
  updateJobList as onUpdateJobList,
  deleteJobList as onDeleteJobList,
} from "../../slices/jobs/thunk";

//redux
import { useSelector, useDispatch } from "react-redux";

import {
  Col,
  Row,
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
  Label,
} from "reactstrap";

//flatpickr
import "flatpickr/dist/themes/material_green.css";
import { createSelector } from "reselect";
import Spinners from "Components/Common/Spinner";
import { ToastContainer } from "react-toastify";

import { pagos } from "common/data";
import { useTranslation } from "react-i18next";

const ListPay = () => {
  //meta title
  document.title = "Mass Transfer";

  const { t } = useTranslation();

  const dispatch = useDispatch<any>();

  const selectProperties = createSelector(
    (state: any) => state.jobs,
    (jobs) => ({
      jobs: pagos,
      loading: false,
    })
  );
  const { jobs, loading } = useSelector(selectProperties);
  const [isLoading, setLoading] = useState<boolean>(loading);

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [job, setJob] = useState<any>(null);
  const [jobList, setJobList] = useState<any>();

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      jobId: (job && job.jobId) || "",
      title: (job && job.title) || "",
      companyName: (job && job.companyName) || "",
      location: (job && job.location) || "",
      experience: (job && job.experience) || "",
      position: (job && job.position) || "",
      type: (job && job.type) || "",
      status: (job && job.status) || "",
    },
    validationSchema: Yup.object({
      jobId: Yup.string().required("Please Enter Your Job Id"),
      title: Yup.string().required("Please Enter Your Job Title"),
      companyName: Yup.string().required("Please Enter Your Company Name"),
      location: Yup.string().required("Please Enter Your Location"),
      experience: Yup.string().required("Please Enter Your Experience"),
      position: Yup.number().required("Please Enter Your Position"),
      type: Yup.string().required("Please Enter Your Type"),
      status: Yup.string().required("Please Enter Your Status"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const updateJobList = {
          id: job ? job.id : 0,
          jobId: values.jobId,
          title: values.title,
          companyName: values.companyName,
          location: values.location,
          experience: values.experience,
          position: values.position,
          type: values.type,
          postedDate: "02 June 2021",
          lastDate: "25 June 2021",
          status: values.status,
        };
        // update Job
        dispatch(onUpdateJobList(updateJobList));
        validation.resetForm();
      } else {
        const newJobList = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          jobId: values["jobId"],
          title: values["title"],
          companyName: values["companyName"],
          location: values["location"],
          experience: values["experience"],
          position: values["position"],
          type: values["type"],
          postedDate: "02 June 2021",
          lastDate: "25 June 2021",
          status: values["status"],
        };
        // save new Job
        dispatch(onAddNewJobList(newJobList));
        validation.resetForm();
      }
      toggle();
    },
  });

  useEffect(() => {
    if (jobs && !jobs.length) {
      dispatch(onGetJobList());
    }
  }, [dispatch, jobs]);

  useEffect(() => {
    setJobList(jobs);
  }, [jobs]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setJob(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false);

  const handleDeletejob = () => {
    if (job) {
      dispatch(onDeleteJobList(job.id));
      setDeleteModal(false);
    }
  };
  const handleJobClicks = () => {
    setIsEdit(false);
    setJob(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: "No",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return (
            <Link to="#" className="text-body fw-bold">
              {cellProps.row.original.id}
            </Link>
          );
        },
      },
      {
        header: "empleado",
        accessorKey: "empleado",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "puesto",
        accessorKey: "puesto",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "salario",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "salario",
      },
      {
        header: "fechaPago",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "fechaPago",
      },
      {
        header: "montoEditable",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "montoEditable",
        cell: (cellProps: any) => {
          return (
            <Input type="number" placeholder="Monto" min={0} defaultValue={0} />
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={`${t("Mass transfers")}`}
            breadcrumbItem={`${t("Pay List")}`}
          />
          <Row>
            <Col lg={12}>
              {isLoading ? (
                <Spinners setLoading={setLoading} />
              ) : (
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex justify-content-between align-items-end">
                      <CardTitle tag="h5" className="mb-0 flex-grow-1">
                        Asingar Nombre a la Tabla:
                        <Input
                          style={{ width: 500 + "px" }}
                          type="text"
                          placeholder="Nombre de la Lista"
                        />
                      </CardTitle>
                      <div className="flex-shrink-0">
                        <Button
                          to="#"
                          onClick={() => handleJobClicks()}
                          className="btn btn-success me-1"
                        >
                          CVS
                        </Button>
                        <Button
                          to="#"
                          onClick={() => handleJobClicks()}
                          className="btn btn-warning me-1"
                        >
                          Template
                        </Button>
                        <Button
                          to="#"
                          onClick={() => handleJobClicks()}
                          className="btn btn-info me-1"
                        >
                          Upload CVS
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={jobList || []}
                      isCustomPageSize={true}
                      isGlobalFilter={true}
                      isJobListGlobalFilter={false}
                      isPagination={true}
                      SearchPlaceholder="Search for ..."
                      tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                    <Row>
                      <CardBody className="border-bottom">
                        <div className="d-flex align-items-center">
                          <CardTitle tag="h5" className="mb-0 flex-grow-1">
                            Lista Detallada
                          </CardTitle>
                          <div className="flex-shrink-0">
                            <Button to="#" className="btn btn-success me-1">
                              Guardar
                            </Button>
                            <Button to="#" className="btn btn-danger me-1">
                              Pagar
                            </Button>
                          </div>
                        </div>
                      </CardBody>
                    </Row>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default ListPay;
